import { TrashIcon } from '@heroicons/react/24/solid';
import { Button } from 'src/components/button';
import { useImportConfiguration } from 'src/context/import-configuration';

function ImportConfigurationStepFiles() {
  const { dialogState, removeImportedFile } = useImportConfiguration();

  if (!dialogState) return null;

  return (
    <div className="w-full space-y-1">
      <p className="text-sm text-gray-500">
        {dialogState.decodedFiles.length} configuration file(s) decoded
        successfully.
        {dialogState.failedFiles > 0
          ? ` ${dialogState.failedFiles} file(s) failed.`
          : ''}
      </p>

      <div className="space-y-2">
        {dialogState.decodedFiles.map((decodedFile) => (
          <div
            key={decodedFile.id}
            className="flex items-center justify-between rounded-md border border-gray-100 bg-white px-3 py-2"
          >
            <div className="min-w-0">
              <p className="truncate text-sm font-medium text-gray-800">
                {decodedFile.fileName}
              </p>
              {/* <p className="text-xs text-gray-500">
                {decodedFile.devicesCounts} device(s)
              </p> */}
            </div>
            <Button
              color="red"
              size="sm"
              onClick={() => removeImportedFile(decodedFile.id)}
              disabled={dialogState.decodedFiles.length <= 1}
            >
              <TrashIcon className="h-4 w-4" />
            </Button>
          </div>
        ))}
      </div>

      {!!dialogState.warnings.length && (
        <div className="max-h-28 overflow-y-auto rounded-md bg-amber-50 p-3 text-sm text-amber-700">
          {dialogState.warnings.map((warning) => (
            <p key={warning}>{warning}</p>
          ))}
        </div>
      )}
    </div>
  );
}

export default ImportConfigurationStepFiles;
